var map = {
	"./nav_bt_2_ns.png": "8vMu",
	"./nav_bt_2_s.png": "hbWl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ptIH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st ^\.\/nav_bt_2_.*\.png$
// module id = ptIH
// module chunks = 0